import { cx } from "@/utils";

import styles from "./Container.module.css";

export type ContainerProps = {
  children: React.ReactNode;
  center?: boolean;
  article?: boolean;
  fullWidth?: boolean;
  className?: string;
  padding?: "regular" | "none";
  background?: "white" | "transparent";
};

const Container: React.FunctionComponent<ContainerProps> = ({
  children,
  center = false,
  className,
  article = false,
  padding = "regular",
  fullWidth = false,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cx(
        styles.root,
        {
          [styles.fullWidth]: fullWidth,
          [styles.article]: article,
          [styles[`padding-${padding}`]]: padding && padding !== "none",
          [styles.center]: center,
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;
